import { render, staticRenderFns } from "./ModalReturn.vue?vue&type=template&id=5456f862&scoped=true"
import script from "./ModalReturn.vue?vue&type=script&lang=js"
export * from "./ModalReturn.vue?vue&type=script&lang=js"
import style0 from "./ModalReturn.vue?vue&type=style&index=0&id=5456f862&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5456f862",
  null
  
)

export default component.exports